import HeroSection from "./sections/HeroSection.jsx";
import HighlightsSection from "./sections/HighlightsSection.jsx";
import HowItWorksSection from "./sections/HowItWorksSection.jsx";
import TestimonialsSection from "./sections/TestimonialsSection.jsx";
import PackagesSection from "./sections/PackagesSection.jsx";
import AboutUsSection from "./sections/AboutUsSection.jsx";
import CallToActionSection from "./sections/CallToActionSection.jsx";

export default function HomePage() {

  return (
    <div className="min-h-screen bg-[var(--color-warm-50)]">
      <HeroSection />
      <HighlightsSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <PackagesSection />
      <AboutUsSection />
      <CallToActionSection />
    </div>
  );
}